import { GpsDataStatus } from 'app/constants/gpsDataStatus'

export const getGpsDataStatusName = (
  gpsDataStatus: GpsDataStatus,
  translate: (string) => string,
): string => {
  const text: string = GpsDataStatus[gpsDataStatus]
  return translate(`gpsDataStatus.${text}`)
}
